/*
|
|               Suppliers
_______________________________________________
|
|    This class keep all fields for 
|    new suppliers.
|
*/

export class Supplier {
    account_number                  :string     = '';
    city                     		:string  	= '';
    contact                         :string  	= '';
    country				            :string  	= '';
    custom                          :boolean    = false;
    emails            				:string[]   = [ '' ]; 
    fax             				:string  	= '';
    id                              :any        = '';
    name                            :string     = '';
    phone                           :string  	= '';
    notes                           :string     = '';
    state                		    :string  	= '';
    street                   		:string  	= '';
    website           				:string  	= '';
    zipCode       			        :string  	= '';
}


// WEBPACK FOOTER //
// /root/anvel/angular/classes/Supplier.ts